import React from 'react';
import { useToast } from '../../context/ToastContext';
import './ToastNotification.css';

const ToastNotification = () => {
  const { toasts, removeToast } = useToast();

  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="toast-container-fixed">
      {toasts.map((toast) => {
        const isSuccess = toast.type === 'success';

        return (
          <div
            key={toast.id}
            className={`toast-item ${isSuccess ? 'toast-item-success' : 'toast-item-error'}`}
          >
            <div className="d-flex align-items-center gap-2 toast-content-wrapper">
              <i
                className={`fa ${isSuccess ? 'fa-check-circle' : 'fa-exclamation-circle'} toast-icon`}
              ></i>
              <span>{toast.message}</span>
            </div>
            <button
              type="button"
              onClick={() => removeToast(toast.id)}
              className="toast-close-btn"
              aria-label="Close notification"
            >
              &times;
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default ToastNotification;
